import React from 'react';
import { useInstantSearch, useStats } from 'react-instantsearch';

const NoResults = () => {
    const { nbHits } = useStats();
    const { results } = useInstantSearch();

    if (results.__isArtificial || nbHits > 0) {
        return null;
    }

    return (
        <div className="grid -col3 -listing">
            <div>
                <h4 className="heading" style={{ color: '#000000' }}>
                    We could not find what you are looking for. Please modify your search and try again.
                </h4>
            </div>
        </div>
    );
};

export default NoResults;
